import React from 'react';
import { Page } from '../Page';
import { Logo } from '../Logo';
export function Page1() {
  return <Page hideFooter variant="dark" data-id="element-687" data-mp="19g5q3a4v1u7i">
      {/* Full-bleed background image */}
      <div className="absolute inset-0 z-0" data-id="element-688" data-mp="1eg1s53tzzbkf">
        <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&q=80" alt="Healthy meal preparation" className="w-full h-full object-cover" data-id="element-689" data-mp="1eez4d4rz1p8q" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/80 via-charcoal/60 to-charcoal/90" data-id="element-690" data-mp="1nfx8ro6bnyru" />
      </div>

      <div className="flex-1 flex flex-col justify-between relative z-10" data-id="element-691" data-mp="1sdgmmmz3y9j9">
        {/* Top: Logo */}
        <div className="pt-4" data-id="element-692" data-mp="1x8cpki5vuhb5">
          <img src="https://cdn.magicpatterns.com/uploads/oG8aVK1qBACM4upmyDQtwJ/file_0000000081b8722fb80a3dcf6435ffdb__1_-removebg-preview.png" alt="Structured Nutrition logo" className="w-32 h-32 object-contain" data-id="element-693" data-mp="22532iwme4wsc" />
        </div>

        {/* Center: Title */}
        <div className="flex-1 flex flex-col justify-center -mt-8" data-id="element-694" data-mp="13pyxuaapvq1o">
          <div className="w-16 h-0.5 bg-tealslate mb-8" data-id="element-695" data-mp="13n30an2s73dr" />
          <h1 className="font-serif text-6xl text-white leading-[1.15] mb-6" data-id="element-696" data-mp="ypjmtpdwqumv">
            The GLP-1
            <br data-id="element-697" data-mp="ts1adp0olxa4" />
            <span className="text-lightteal" data-id="element-698" data-mp="tri1sywx8l8r">Nutrition</span>
            <br data-id="element-699" data-mp="osyhf2xz7hii" />
            Guide
          </h1>
          <p className="font-sans text-sm text-[#E5E5E5]/80 max-w-sm leading-[1.8] mb-10" data-id="element-700" data-mp="ou9fqn8njx28">
            Your essential guide to nutrition, supplements, and building
            sustainable habits on GLP-1 medication.
          </p>
        </div>

        {/* Bottom: Author */}
        <div className="pb-2" data-id="element-701" data-mp="1cojbgx1f79j1">
          <div className="w-10 h-px bg-tealslate/60 mb-4" data-id="element-702" data-mp="1cnrebhs6d3qn" />
          <p className="font-sans text-xs text-[#9CA3AF] tracking-[0.15em] uppercase" data-id="element-703" data-mp="17q9au6wxfgq1">
            By Jack Achenbach MS, RDN, CPT
          </p>
        </div>
      </div>
    </Page>;
}